import TimePicker from './timePicker.vue'
export default TimePicker
